import { Component, Input, OnInit } from '@angular/core';
import { LISRatesResponsePayload, LISRateObj } from './interfaces/lis-rates-payload.interface';
import { LisRatesService } from './services/lis-rates.service';
import { environment } from 'src/environments/environment';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { EffectiveDateStateStructure } from '../../shared/components/configs/interfaces/effective-date.state-structure.interface';
import { select } from '@ptl/angular-redux-store';
import { Observable } from 'rxjs';
//import * as moment from 'moment';
import moment from 'moment';
import { DateService } from 'src/app/shared/services/date.service';

@Component({
    selector: 'app-lis-rates',
    templateUrl: './lis-rates.component.html',
    styleUrls: ['./lis-rates.component.scss'],
    standalone: false
})
export class LisRatesComponent implements OnInit {
  @Input() currentYearLabel: string;
  @Input() nextYearLabel: string;

  dataSourceCurrentYear: LISRateObj[];
  dataSourceNextYear: LISRateObj[];

  currentYear: number;
  nextYear: number;

  showNextYearsPlans: boolean = false;
  showSpinner: boolean = false;
 
  @select(['appStates', 'ShoppingDates'])
  shoppingDates$: Observable<any>;

  displayedColumns: string[] = [
    'planName',
    'subsidy_100'
  ]

  constructor(
    public lisRatesService: LisRatesService,
    private reducerUtilityService: ReducerUtilityService,
    private dateUtility: DateService
  ) {
    this.currentYear = this.dateUtility.getTodayAsMoment().year();
    this.nextYear = this.currentYear + 1;

    if (!this.currentYearLabel) {
      this.currentYearLabel = this.currentYear + ' Rates';
    }
    if (!this.nextYearLabel) {
      this.nextYearLabel = this.nextYear + ' Rates';
    }
   
    this.shoppingDates$.subscribe((value) => {
      this.showNextYearsPlans = this.dateUtility.getTodayAsMoment().isSameOrAfter(value.showNextYearProductsDate);
    });
  }

  async ngOnInit() {
    this.showSpinner = true;
    const zipCountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');
    const zipCode = zipCountyState.zipCode;
    if (zipCode && environment.initData.brand.ASPID) {
      const data: LISRatesResponsePayload = await this.lisRatesService.getLisRates(this.currentYear, this.nextYear);
      this.dataSourceCurrentYear = data.lisRates[this.currentYear];
      this.dataSourceNextYear = data.lisRates[this.nextYear];
    }
    this.showSpinner = false;
  }

}
